import React from "react";

import { collectMachinePanelPhotos } from "./operationMachinePhotos";

export default function OperationMachinePhotosPanel({
  machineIdent,
  fieldEvents,
  fuelRecords,
  panelPhotos,
  formatTimestamp,
  onOpenPhoto,
  t,
}) {
  const photos = collectMachinePanelPhotos(
    fieldEvents,
    fuelRecords,
    panelPhotos
  );

  return (
    <div className="operation-machine-photos-panel">
      <div className="operation-machine-photos-head">
        <div>
          <strong>{t("Fotos do painel")}</strong>
          <p className="operation-machine-photos-desc">
            {t(
              "Imagens enviadas pelo tablet ao abastecer ou assumir a máquina {{machine}}.",
              { machine: machineIdent || "—" }
            )}
          </p>
        </div>
        <span className="operation-machine-photos-count">
          {photos.length}{" "}
          {photos.length === 1 ? t("foto") : t("fotos")}
        </span>
      </div>

      {photos.length === 0 ? (
        <p className="operation-machine-photos-empty text-muted">
          {t(
            "Nenhuma foto sincronizada para esta máquina no período. Verifique conexão do tablet e tente um novo registro no app."
          )}
        </p>
      ) : (
        <div className="operation-machine-photos-grid">
          {photos.map((photo) => (
            <button
              key={`${photo.url}-${photo.timestamp}`}
              type="button"
              className="operation-machine-photo-card"
              onClick={() => onOpenPhoto(photo.url)}
              title={t("Ampliar foto")}
            >
              <img
                src={photo.url}
                alt={t("Foto do painel — {{label}}", { label: photo.label })}
                loading="lazy"
              />
              <span className="operation-machine-photo-caption">
                <strong>{photo.label}</strong>
                {photo.operatorName ? (
                  <span>{photo.operatorName}</span>
                ) : null}
                <span>{formatTimestamp(photo.timestamp)}</span>
                {photo.liters != null && photo.liters !== "" ? (
                  <span>{photo.liters} L</span>
                ) : null}
                {photo.hourMeter != null && photo.hourMeter !== "" ? (
                  <span>
                    {t("Horímetro")} {photo.hourMeter}
                  </span>
                ) : null}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
